import React, { useEffect } from "react";
import IconInfo from "../../Icons/NotificationMessage/Info";
import IconSuccess from "../../Icons/NotificationMessage/Success";
import IconWarning from "../../Icons/NotificationMessage/Warning";
import IconError from "../../Icons/NotificationMessage/Error";
import Modal from "./Modal";
import "./Notification.css";
import { ENotificationType } from "../../Model/ENotificationType";

/* Animation Time */
const FADE_OUT_DURATION = 1;
const ACTIVE_DURATION = 10;

type Props = {
  type: ENotificationType;
  message?: string;
  active: boolean;
  onClose: () => void;
};

const Notification = ({ type, message, active, onClose }: Props) => {
  let classMessage = "modal-notif";
  let iconMessage = null;
  switch (type) {
    case ENotificationType.Info:
      classMessage += " info";
      iconMessage = <IconInfo fill="#2F80ED" />;
      break;
    case ENotificationType.Warning:
      classMessage += " warning";
      iconMessage = <IconWarning />;
      break;
    case ENotificationType.Error:
      classMessage += " error";
      iconMessage = <IconError />;
      break;
    case ENotificationType.Success:
      classMessage += " success";
      iconMessage = <IconSuccess />;
      break;
  }

  useEffect(() => {
    if (type !== ENotificationType.Error && active) {
      setTimeout(() => {
        onClose();
      }, (ACTIVE_DURATION + FADE_OUT_DURATION) * 1000);
    }
  }, [type]);

  const getStyle = () => {
    if (type !== ENotificationType.Error && active) {
      return {
        animation: `modal-notif-animation ${FADE_OUT_DURATION}s ease ${ACTIVE_DURATION}s 1 normal forwards`,
      };
    }
    return {};
  };

  return (
    <Modal
      className={classMessage}
      onHide={onClose}
      show={active}
      style={getStyle()}
      styleBackdrop={{ backgroundColor: "rgba(0,0,0,0)", zIndex: 1001 }}
    >
      <Modal.Body className="notif-body">
        <div className="icon">{iconMessage}</div>
        <div className="message">
          <pre>{message}</pre>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Notification;
